import axios from "axios/index";
import api from "./api/login.api";
import config from "@/config";

const loginUrl = config.hostLogin;

export default {
  /**
   * 手机号注册
   */
  mobileRegister(params, headers) {
    return axios.post(loginUrl + api.mobileRegister, params, {headers: headers});
  },
  /**
   * 发送验证码
   */
  sendMobileCode(params) {
    return axios.post(loginUrl + api.sendMobileCode, params);
  },
  /**
   * 校验验证码
   */
  checkMobileCode(params) {
    return axios.post(loginUrl + api.checkMobileCode, params);
  },
  /**
   * 账号登录
   */
  loginByAccount(params) {
    return axios.post(loginUrl + api.loginByAccount, params);

  },
  /**
   * 验证码登录
   */
  loginByMobileCaptcha(params) {
    return axios.post(loginUrl + api.loginByMobileCaptcha, params);
  },
  /**
   * 忘记密码
   */
  forgetPassword(params) {
    return axios.post(loginUrl + api.forgetPassword, params);
  },
  /**
   * 根据code获取openId
   */
  getOpenId(params) {
    return axios.get(loginUrl + api.getOpenId, { params: params });
  },
  /**
   * 微信登录
   */
  wxLogin(params) {
    return axios.post(loginUrl + api.wxLogin, params);
  },
  /**
  * 微信登录
  */
  wxBind(params) {
    return axios.post(loginUrl + api.wxBind, params);
  },
  /**
   * 修改密码
   */
  changePassword(params) {
    return axios.post(loginUrl + api.changePassword, params);
  },
};
